export const PRIMARY_OWNER_EMAIL = 'akingbade849@gmail.com';

export const normalizeEmail = (email?: string | null) => email?.trim().toLowerCase() ?? '';

export const isOwnerEmail = (email?: string | null) =>
  normalizeEmail(email) === normalizeEmail(PRIMARY_OWNER_EMAIL);
